export default "__VITE_ASSET__BsV8FzlZ__"